import type { ReactNode } from 'react'

import { useNavigate } from 'react-router-dom'

import * as S from '../styles'

interface SidebarItemProps {
  label: string
  icon: ReactNode
  active?: boolean
  onClick?: () => void
  route?: string
  disabled?: boolean
}

export const SidebarItem = ({
  label,
  icon,
  active = false,
  route,
  onClick,
  disabled = false,
}: SidebarItemProps) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    e.stopPropagation()

    if (onClick) {
      onClick()
    } else if (route) {
      navigate(route)
    }
  }

  return (
    <S.StyledItem active={active} disabled={disabled} onClick={handleClick}>
      {icon}
      <span>{label}</span>
    </S.StyledItem>
  )
}
